<template>
    <small-dialog
        @ok="reset"
        v-model="dialog"
        title="Reset Try Out?"
        no-activator
        color="red"
        okButton="reset"
        loading="delete"
    >
        <div v-if="history && enrollment && user">
            Reset try out {{ history.tryout.title }} - {{ enrollment.period.title }} oleh {{ user.name }}
        </div>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        dialog: false,
        user: null,
        history: null,
        enrollment: null,
    }),

    methods: {
        show(user, history, enrollment) {
            this.user = user
            this.history = history
            this.enrollment = enrollment
            this.dialog = true
        },

        async reset() {
            await this.$apiv2.delete(`tryout-history/${this.history.id}`, { loader: 'delete' })
            this.$emit('delete')

            this.dialog = false
            this.user = null
            this.history = null
            this.enrollment = null
        }
    }
}
</script>
